<template>
  <div class="error-page-content" :class="classObject">
    <div class="error-page-content__icon">
      <svg
        v-if="type === 'not-found'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 7.5C15.825 7.5 16.5 8.175 16.5 9V15C16.5 15.825 15.825 16.5 15 16.5C14.175 16.5 13.5 15.825 13.5 15V9C13.5 8.175 14.175 7.5 15 7.5ZM14.985 0C6.705 0 0 6.72 0 15C0 23.28 6.705 30 14.985 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 14.985 0ZM15 27C8.37 27 3 21.63 3 15C3 8.37 8.37 3 15 3C21.63 3 27 8.37 27 15C27 21.63 21.63 27 15 27ZM16.5 22.5H13.5V19.5H16.5V22.5Z"
          fill="#C4C4C4"
        />
      </svg>
      <svg
        v-if="type === 'session'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.985 0C6.705 0 0 6.72 0 15C0 23.28 6.705 30 14.985 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 14.985 0ZM15 27C8.37 27 3 21.63 3 15C3 8.37 8.37 3 15 3C21.63 3 27 8.37 27 15C27 21.63 21.63 27 15 27ZM14.67 7.5H14.58C13.98 7.5 13.5 7.98 13.5 8.58V15.66C13.5 16.185 13.77 16.68 14.235 16.95L20.46 20.685C20.97 20.985 21.63 20.835 21.93 20.325C22.245 19.815 22.08 19.14 21.555 18.84L15.75 15.39V8.58C15.75 7.98 15.27 7.5 14.67 7.5Z"
          fill="#C4C4C4"
        />
      </svg>
      <svg
        v-if="type === 'login'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.985 0C6.705 0 0 6.72 0 15C0 23.28 6.705 30 14.985 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 14.985 0ZM15 27C8.37 27 3 21.63 3 15C3 8.37 8.37 3 15 3C21.63 3 27 8.37 27 15C27 21.63 21.63 27 15 27ZM14.67 7.5H14.58C13.98 7.5 13.5 7.98 13.5 8.58V15.66C13.5 16.185 13.77 16.68 14.235 16.95L20.46 20.685C20.97 20.985 21.63 20.835 21.93 20.325C22.245 19.815 22.08 19.14 21.555 18.84L15.75 15.39V8.58C15.75 7.98 15.27 7.5 14.67 7.5Z"
          fill="#C4C4C4"
        />
      </svg>
      <svg
        v-if="type === 'member-card'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5960_168226)">
          <path
            d="M27 3H3C1.335 3 0.015 4.335 0.015 6L0 24C0 25.665 1.335 27 3 27H27C28.665 27 30 25.665 30 24V6C30 4.335 28.665 3 27 3ZM25.5 24H4.5C3.675 24 3 23.325 3 22.5V15H27V22.5C27 23.325 26.325 24 25.5 24ZM27 9H3V6H27V9Z"
            fill="#C4C4C4"
          />
        </g>
        <defs>
          <clipPath id="clip0_5960_168226">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
        >
      </svg>
      <svg
        v-if="type === 'maintenance'"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5927_168403)">
          <path
            d="M6.11843 8.19305L11.0147 13.1021C11.8552 12.2955 12.5839 11.5961 13.1305 11.0705L8.19119 6.11935L7.58691 3.44051L3.17961 0.761719L1.97018 1.97209L0.760742 3.18146L3.43959 7.58883L6.11843 8.19305Z"
            fill="#C4C4C4"
          />
          <path
            d="M20.9976 16.1895L28.2377 23.4066C29.5725 24.7405 29.5725 26.9039 28.2377 28.2387C26.9028 29.5727 24.7403 29.5727 23.4055 28.2387L16.1655 21.0216L20.9976 16.1895Z"
            fill="#C4C4C4"
          />
          <path
            d="M26.9505 11.9185C29.4435 9.65622 29.86 7.08542 29.3025 4.91745C29.2861 4.74531 29.2449 4.6007 29.0947 4.49265L28.593 4.08156C28.506 4.00005 28.3888 3.96068 28.2716 3.97169C28.1535 3.98359 28.0464 4.044 27.9768 4.14015L25.0911 7.89197C25.0105 8.00277 24.8805 8.06593 24.7441 8.06136L23.6967 8.13829C23.607 8.13554 23.52 8.10349 23.4495 8.04671L21.4262 6.33191C21.3439 6.26505 21.2898 6.16984 21.2761 6.06454L21.1506 5.11603C21.136 5.01167 21.1625 4.90544 21.2248 4.81937L23.9265 1.149C24.0492 0.980543 24.0254 0.747105 23.8734 0.605191L23.2179 0.0924962C23.0897 -0.0265077 22.9441 -0.0100429 22.7454 0.0283946C20.8796 0.396422 17.6935 2.20369 16.8851 4.70124C16.1728 6.89945 16.4209 8.44943 16.4209 8.44943C16.4209 9.68816 16.0135 10.882 15.5127 11.3828L1.43569 24.8979C1.40821 24.9226 1.38166 24.9482 1.35512 24.9748C0.192386 26.1376 0.194203 28.0245 1.31756 29.1478C2.44092 30.2712 4.35618 30.3005 5.51891 29.1378C5.57293 29.0837 5.62514 29.0279 5.67366 28.9702L19.2482 14.2961C20.9181 12.8093 24.2241 14.3932 26.9505 11.9185Z"
            fill="#C4C4C4"
          />
        </g>
        <defs>
          <clipPath id="clip0_5927_168403">
            <rect width="30" height="30" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <svg
        v-if="type === 'cookie'"
        width="36"
        height="33"
        viewBox="0 0 36 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_13407_37453)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.973 3.44776L35.0657 22.6567C37.7203 27.2537 34.402 33 29.0927 33H6.90731C1.59798 33 -1.72035 27.2537 0.934315 22.6567L12.027 3.44776C14.6817 -1.14925 21.3183 -1.14926 23.973 3.44776ZM21.4131 4.92537C19.8962 2.29851 16.1038 2.29851 14.5869 4.92537L3.49417 24.1343C1.97722 26.7612 3.87341 30.0448 6.90731 30.0448H29.0927C32.1266 30.0448 34.0228 26.7612 32.5058 24.1343L21.4131 4.92537Z"
            fill="#FF0000"
          />
          <path
            d="M19.5 12.5C19.5 11.675 18.825 11 18 11C17.175 11 16.5 11.675 16.5 12.5V18.5C16.5 19.325 17.175 20 18 20C18.825 20 19.5 19.325 19.5 18.5V12.5Z"
            fill="#FF0000"
          />
          <path d="M16.5 26H19.5V23H16.5V26Z" fill="#FF0000" />
        </g>
        <defs>
          <clipPath id="clip0_13407_37453">
            <rect width="36" height="33" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <p class="error-page-content__lead">
      <strong>{{ unescapedSummary }}</strong>
    </p>
    <p class="error-page-content__body">{{ unescapedMessage }}</p>
    <div
      v-if="type !== 'maintenance' && !isIframe && showButton"
      class="error-page-content__footer"
    >
      <arrow-button
        :text="buttonText"
        direction="right"
        button-color="light"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const runtimeConfig = useRuntimeConfig()

const props = defineProps({
   /**
   * HTTPレスポンスステータスコード
   */
    statusCode: {
    type: Number,
    required: true,
  },
  /**
   * APIレスポンスエラーコード
   */
  apiCode: {
    type: Number,
    required: true,
  },
  /**
   * エラーメッセージの概要
   */
  summary: {
    type: String,
    required: true,
  },
  /**
   * エラーメッセージ
   */
  message: {
    type: String,
    required: true,
  },
  /**
   * iframeかどうか
   */
  isIframe: {
    type: Boolean,
    default: false,
  },
  activeMyStoreId: {
    type: [String],
    default: null,
  },
  cookieError: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['logout'])

const apiCodeType = ref({
  10000: 'not-found',
  10003: 'not-found',
  10004: 'not-found',
  10301: 'not-found',
  10302: 'not-found',
  10311: 'not-found',
  99999: 'not-found',
  10202: 'session',
  10209: 'session',
  10001: 'login',
  10002: 'login',
  10005: 'login',
  10006: 'login',
  10007: 'login',
  10051: 'member-card',
  90001: 'maintenance',
})

const icon = ref({})
const innerWidth = ref(window.innerWidth)
const tabletBreakpoint = ref(744)
const setTimeoutId = ref(null)

const classObject = computed(() => {
  return {
    iframe: props.isIframe,
  }
})

const type = computed(() => {
  let type = ''
  if (props.cookieError) {
    type = 'cookie'
  }
  else if (props.statusCode === 404) {
    type = 'not-found'
  } else if (apiCodeType.value[props.apiCode]) {
    type = apiCodeType.value[props.apiCode]
  } else {
    type = 'not-found'
  }
  return type
})

const unescapedSummary = computed(() => {
  return props.summary.replace(/\\n/g, '\n')
})

const unescapedMessage = computed(() => {
  return props.message.replace(/\\n/g, '\n')
})

const isBackButtonContentFit = computed(() => {
  return innerWidth.value > tabletBreakpoint.value
})

const buttonText = computed(() => {
  if (props.cookieError) {
    return '再読み込み'
  } else {
    return 'ホームにもどる'
  }
})

const isSingleStore = computed(() => {
  return runtimeConfig.public.singleStore
})

const resizeHandler = () => {
  // リサイズ間引き処理
  if (setTimeoutId.value) return

  setTimeoutId.value = setTimeout(() => {
    innerWidth.value = window.innerWidth
    setTimeoutId.value = null
  }, 500)
}

const handleClick = () => {
  if (props.cookieError) {
    location.reload()
  } else if (props.statusCode === 401) {
    emit('logout')
    redirectHome()
  } else {
    redirectHome()
  }
}

const redirectHome = () => {
  if (route.name === 'index') {
    location.href = runtimeConfig.public.chirashiUrl
  } else {
    router.push(
      props.activeMyStoreId !== null && props.activeMyStoreId !== undefined
        ? `/chirashi/?shop-id=${props.activeMyStoreId}`
        : `/my-store/search/`
    )
  }
}

const showButton = computed(() => {
  if (isSingleStore.value) {
    return props.activeMyStoreId !== null && props.activeMyStoreId !== undefined
  } else {
    return true
  }
})

onMounted(() => {
  window.addEventListener('resize', resizeHandler)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeHandler)
})
</script>

<style lang="scss" scoped>
.error-page-content {
  padding: 1.6rem;
  background-color: $color-bg;
  box-sizing: border-box;
  @media screen and (min-width: $tablet-breakpoint) {
    padding: 6rem 2.5rem 6rem 2.5rem;
  }

  .error-page-content__icon {
    width: 3rem;
    height: 3rem;
    margin: 0 auto;
  }

  .error-page-content__lead {
    margin-top: 1.5rem;
    color: $color-alert;
    font-size: 1.6rem;
    font-weight: bold;
    line-height: calc(24 / 16);
    text-align: center;
    white-space: pre-wrap;
    @media screen and (min-width: $tablet-breakpoint) {
      letter-spacing: 0.065em;
    }
  }

  .error-page-content__body {
    margin-top: 1.5rem;
    font-size: 1.6rem;
    line-height: calc(24 / 16);
    white-space: pre-wrap;
    color: $color-gray-text;
    text-align: center;
    @media screen and (min-width: $tablet-breakpoint) {
      max-width: 58.8rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .error-page-content__footer {
    width: auto;
    margin: 2.4rem auto 0;
    text-align: center;
    @media screen and (min-width: $tablet-breakpoint) {
      width: 30rem;
    }
  }

  &.iframe {
    background-color: transparent;
    padding: 0 !important;
  }
}
</style>
